import { Box, Typography } from "@material-ui/core"
import { clearApiToken, getGroupPurchaseGetGroupPurchaseSettings } from "api"
import { useIsDesktop } from "common/MediaQueries"
import GenericButton from "components/GenericButton/GenericButton"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import NextLink from "components/Reusable/Bit/NextLink"
import Image from "next/image"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import styled from "styled-components"

const StyledWrapper = styled(Box)`
  display: grid;
  width: 100%;
  align-items: flex-start;
  justify-items: center;
  grid-template-columns: 1fr;
  gap: 40px;
  padding: 0 16px;
  margin-top: 100px;
  margin-bottom: 90px;
  ${(p) => p.theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 1fr;
    justify-items: end;
    gap: 60px;
    margin-top: 203px;
    margin-bottom: 144px;
    padding-right: 60px;
    padding-left: 120px;
  }
`

const StyledDiv = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100%;
  ${(p) => p.theme.breakpoints.up("md")} {
    align-items: flex-start;
  }
`

const StyledMainTitle = styled(Typography).attrs({ variant: "h1" })`
  margin: 0;
  margin-bottom: 10px;
  font-size: 50px;
  font-weight: 900;
  line-height: 40px;
  color: #000000;
  text-align: center;
  ${(p) => p.theme.breakpoints.up("md")} {
    text-align: right;
  }
`

const StyledText = styled("p")`
  margin: 0;
  font-size: 24px;
  font-weight: 400;
  line-height: 30px;
  color: #000000;
  text-align: center;
  ${(p) => p.theme.breakpoints.up("md")} {
    text-align: right;
  }
`

const StyledButtonWrapper = styled.div<{ $marginTop?: string }>`
  margin-top: ${(p) => p?.$marginTop || 0}px;
  margin-top: 40px;
`

const SuccessPaymentSecondary = ({
  mainTitle,
  secondaryTitle,
}: {
  mainTitle?: string
  secondaryTitle?: string
}) => {
  const isDesktop = useIsDesktop()
  const router = useRouter()
  const isGroupPurchase = router.pathname.includes("groupPurchases")
  const [coverImg, setCoverImg] = useState({
    imageUrl: "",
    alt: "",
  })
  const { groupPurchaseData } = usePurchaseContext()
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getGroupPurchaseGetGroupPurchaseSettings()
        setCoverImg(response?.data?.body?.image)
      } catch (error) {
        console.error(error)
      }
    }
    fetchData()
  }, [])

  useEffect(() => {
    if (document) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }, [])

  useEffect(() => {
    clearApiToken()
  }, [])

  const redirectToHomepage = (e) => {
    e.preventDefault()
    router.push("/").then(() => {
      window.location.reload()
    })
  }

  return (
    <StyledWrapper>
      {coverImg?.imageUrl && (
        <Image
          src={coverImg.imageUrl}
          alt={coverImg.alt}
          layout="fixed"
          width={isDesktop ? "422px" : "243px"}
          height={isDesktop ? "245px" : "142px"}
          style={{
            borderRadius: "22px",
            objectFit: "cover",
          }}
        />
      )}
      <StyledDiv>
        {!mainTitle ? (
          <>
            <StyledMainTitle>
              איזה כיף הוספנו את התשלום שלך לקבוצת {isDesktop && <br />}
              {
                //@ts-ignore
                `"${groupPurchaseData?.groupName}"`
              }
            </StyledMainTitle>
          </>
        ) : (
          <StyledMainTitle>{mainTitle}</StyledMainTitle>
        )}
        <StyledText>
          {secondaryTitle || "לאחר ביצוע ההזמנה אנחנו כמובן נשלח לך הודעה"}
        </StyledText>
        <NextLink
          href={"/"}
          style={{ marginTop: "auto" }}
          onClick={redirectToHomepage}
        >
          <StyledButtonWrapper $marginTop={isGroupPurchase ? "40px" : "30px"}>
            <GenericButton width={220} btnType="filled">
              {isGroupPurchase ? "לחזרה לעמוד הבית" : "לדף הבית"}
            </GenericButton>
          </StyledButtonWrapper>
        </NextLink>
      </StyledDiv>
    </StyledWrapper>
  )
}

export default SuccessPaymentSecondary
